import React from 'react'

import { createStore, compose, applyMiddleware } from 'redux'
import { Provider } from 'react-redux'

import createSagaMiddleware from 'redux-saga'

import reducer from './reducers'
import loanApplicationSaga from './sagas';

import Main from './Main'

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

// create the saga middleware
const sagaMiddleware = createSagaMiddleware()

const store = createStore(
  reducer,
  (window.__initialState__ || undefined),
  composeEnhancers(
    applyMiddleware(
      sagaMiddleware,
    )
  ),
)

// run the saga
sagaMiddleware.run(loanApplicationSaga);

const App = (
  <Provider store={store}>
    <Main loanApplicationId={ gon.loan_application.id }/>
  </Provider>
);

export default App;
